import React from "react";
// import your 5 images
import Artboard1 from "../../assets/ravenhousepagesplit-01.webp";
import Artboard2 from "../../assets/ravenhousepagesplit-02.webp";
import Artboard3 from "../../assets/ravenhousepagesplit-03.webp";
import Artboard4 from "../../assets/ravenhousepagesplit-04.webp";


export default function SixImageSections() {
  const images =  [
  Artboard1,
  Artboard2,
  Artboard3,
  Artboard4,
];

  return (
    <>
      {/* Images Section */}
      <div className="flex flex-col gap-0 pt-16 pb-16">
        {images.map((image, index) => (
          <div key={index} className="relative w-full">
            {/* 🔹 Blurred Background */}
            <div
              className="absolute inset-0 bg-cover bg-center blur-2xl"
              style={{ backgroundImage: `url(${Artboard1})` }}
            ></div>

            {/* 🔹 Centered Sharp Container */}
            <div className="relative z-10 flex justify-center items-center py-0 px-4">
              <img
                src={image}
                alt={`Section ${index + 1}`}
                className="max-w-full h-auto"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Logo Section */}
      <section
        style={{
          width: "100%",
          minHeight: "25svh",
          scrollSnapAlign: "start",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          paddingBottom: "40px",
        }}
      >
        <img
          src="/logo.png"
          alt="Logo"
          style={{
            width: "80px",
            height: "auto",
            opacity: 0.9,
          }}
        />
      </section>
    </>
  );
}